module.exports = __webpack_public_path__ + "static/media/cert_126.9229df19.jpg";